import { MdOutlineLocationOn } from "react-icons/md";

const XpressHeaders = () => {
  return (
    <div className="d-flex align-items-center justify-content-start px-4 py-2 border-bottom bg-white gap-2 ">
      <div className="d-flex align-items-center pt-2 ">
        <img
          src="https://homeal-favourites-store.s3.ap-south-1.amazonaws.com/appdata/xpressData/XpressLogo.png"
          alt="Xpress Pods Logo"
          style={{ height: 20, width: 80, marginRight: 5 }}
        />
        <h6>pods</h6>
      </div>
      <div className="d-flex align-items-center px-2 py-1 border border-secondary rounded-pill">
        <MdOutlineLocationOn size={18} />
        <span className="fw-bold" style={{ fontSize: 15 }}>
          Singasandra
        </span>
      </div>
    </div>
  );
};

export default XpressHeaders;
